import styled from "styled-components";


export const TestInputContainer = styled.div`
    width: 250px;
    width: 350px;
    padding: 0 30px;
`